var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Button, CircularProgress, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { uploadFile } from '../../services/documento-anexo.service';
var FileUploadButton = function (_a) {
    var accept = _a.accept, onUpload = _a.onUpload, servicoDocumentoId = _a.servicoDocumentoId, _b = _a.disabled, disabled = _b === void 0 ? false : _b, error = _a.error;
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var handleFileChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var file, fileContract, documento, apiError_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
                    if (!file) return [3 /*break*/, 5];
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, uploadFile(file)];
                case 2:
                    fileContract = _b.sent();
                    documento = {
                        id: 0,
                        nomeOriginal: fileContract.originalName,
                        tamanhoArquivo: fileContract.size,
                        arquivoTipo: fileContract.mimeType,
                        keyArquivo: fileContract.key,
                        urlArquivo: fileContract.url,
                        servicoDocumentoId: servicoDocumentoId,
                    };
                    onUpload(documento);
                    return [3 /*break*/, 5];
                case 3:
                    apiError_1 = _b.sent();
                    console.error('Erro ao fazer o upload do arquivo:', apiError_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var acceptFiles = useMemo(function () {
        if (!accept || (Array.isArray(accept) && accept.length === 0)) {
            return '';
        }
        var extensions = typeof accept === 'string' ? accept.split(',') : accept;
        return extensions.map(function (ext) { return ".".concat(ext.trim().toLowerCase()); }).join(', ');
    }, [accept]);
    return (_jsxs(_Fragment, { children: [_jsxs(Button, { variant: "outlined", fullWidth: true, component: "label", color: error ? 'error' : 'primary', startIcon: loading ? _jsx(CircularProgress, { size: 20 }) : _jsx(AttachFileIcon, {}), disabled: disabled || loading, children: [loading ? 'Carregando...' : 'Anexar Arquivo', _jsx("input", { type: "file", accept: acceptFiles, hidden: true, onChange: handleFileChange, disabled: disabled || loading })] }), error && (_jsx(Typography, { color: "error", variant: "body2", children: error }))] }));
};
export default FileUploadButton;
